import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0ca64162")

_pushScopeId("data-v-0ca64162")
const _hoisted_1 = { class: "face-recognition-enrollment-text" }
const _hoisted_2 = { class: "face-recognition-enrollment-footer" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_button = _resolveComponent("el-button")
  const _component_dialog_shell = _resolveComponent("dialog-shell")

  return (_openBlock(), _createBlock(_component_dialog_shell, {
    title: _ctx.$wordList.FaceRecognitionEnrollmentTitle,
    footerType: "customize",
    width: "520px",
    onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('close')))
  }, {
    footer: _withId(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_el_checkbox, {
          modelValue: _ctx.doNotShowAgain,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.doNotShowAgain = $event))
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$wordList["Don\'t show again"]), 1)
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode("div", null, [
          _createVNode(_component_el_button, {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('close')))
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.$wordList.TabelFootCancel), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.allow
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.$wordList.FaceRecognitionEnrollmentAllow), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ]),
    default: _withId(() => [
      _createVNode("p", _hoisted_1, [
        _createVNode("span", null, _toDisplayString(_ctx.$wordList.FaceRecognitionEnrollmentTipBeforeTerms), 1),
        _createVNode("button", {
          type: "button",
          class: "policy-link",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openTermsOfService && _ctx.openTermsOfService(...args)))
        }, _toDisplayString(_ctx.$wordList.TermsOfService), 1),
        _createVNode("span", null, _toDisplayString(_ctx.$wordList.LoginAnd), 1),
        _createVNode("button", {
          type: "button",
          class: "policy-link",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openPrivacyPolicy && _ctx.openPrivacyPolicy(...args)))
        }, _toDisplayString(_ctx.$wordList.LoginPrivacyPolicy), 1)
      ])
    ]),
    _: 1
  }, 8, ["title"]))
})